import { useMemo } from 'react';

/**
 * Memoizes Immutable.js (or plain) values converted via toJS() so downstream
 * effects do not re-fire on every render from new object references.
 */
export function useImmutableJs(value) {
  return useMemo(() => {
    if (value == null) return null;
    if (typeof value.toJS === 'function') return value.toJS();
    return value;
  }, [value]);
}
